import { configureStore, createSlice } from "@reduxjs/toolkit";
import gameApi from "../services/game";
import userApi from "../services/user";

const homeSlice = createSlice({
  name: "home",
  initialState: {
    count: 1,
    userToken: null,
  },
  reducers: {
    increase: (state) => {
      state.count++;
    },
    decrease: (state) => {
      state.count--;
    },
    setUserToken: (state, action) => {
      state.userToken = action.payload;
    },
  },
});

//remove feedBackApi!!
const store = configureStore({
  reducer: {
    home: homeSlice.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [gameApi.reducerPath]: gameApi.reducer,
  },
  //CACHING WILL BE HANDLED BY THE MIDDLEWARE
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(userApi.middleware)
      .concat(gameApi.middleware),
});

export const homeActions = homeSlice.actions;

export default store;
